import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useCallbackRef } from "use-callback-ref";
/** Detect parent ref by using a <script /> placeholder */
export const useParentRef = () => {
    const [parent, setParent] = useState();
    const placeholderRef = useCallbackRef(null, (ref) => {
        if (ref?.parentElement) {
            setParent(ref.parentElement);
        }
    });
    if (parent) {
        return {
            ref: parent,
        };
    }
    return {
        detector: _jsx("script", { ref: placeholderRef }),
    };
};
export default useParentRef;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUGFyZW50UmVmLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVBhcmVudFJlZi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQWMsRUFBZ0IsUUFBUSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ3RELE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQU9sRCwwREFBMEQ7QUFDMUQsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLEdBQXVCLEVBQUU7SUFDbkQsTUFBTSxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsR0FBRyxRQUFRLEVBQTJCLENBQUM7SUFFaEUsTUFBTSxjQUFjLEdBQUcsY0FBYyxDQUFvQixJQUFJLEVBQUUsQ0FBQyxHQUFHLEVBQUUsRUFBRTtRQUNyRSxJQUFJLEdBQUcsRUFBRSxhQUFhLEVBQUUsQ0FBQztZQUN2QixTQUFTLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQyxDQUFDO1FBQy9CLENBQUM7SUFDSCxDQUFDLENBQUMsQ0FBQztJQUVILElBQUksTUFBTSxFQUFFLENBQUM7UUFDWCxPQUFPO1lBQ0wsR0FBRyxFQUFFLE1BQU07U0FDWixDQUFDO0lBQ0osQ0FBQztJQUVELE9BQU87UUFDTCxRQUFRLEVBQUUsaUJBQVEsR0FBRyxFQUFFLGNBQWMsR0FBSTtLQUMxQyxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxZQUFZLENBQUMifQ==